import { enableGestureExit } from '@mx/core';
import { useEffect } from 'react';

export function useDisableGesture() {
  useEffect(() => {
    /** 禁止手势返回 */
    try {
      enableGestureExit(false);
    } catch (e) {
      console.error(e);
    }
    return () => {
      /** 离开页面后允许手势返回 */
      try {
        enableGestureExit(true);
      } catch (e) {
        console.error(e);
      }
    };
  }, []);
}
